import { useMemo, useState } from "react";
import { events } from "@/mocks/events";
import { categories } from "@/mocks/categories";
import SectionHeading from "./SectionHeading";

export default function EventsSection() {
  const [activeCat, setActiveCat] = useState("全部");
  const [query, setQuery] = useState("");

  const tabs = ["全部", ...categories.map((cat) => cat.name)];

  const filtered = useMemo(() => {
    const keyword = query.trim().toLowerCase();
    return events.filter((item) => {
      const matchCat = activeCat === "全部" || item.category === activeCat;
      const matchQuery =
        keyword.length === 0 ||
        item.title.toLowerCase().includes(keyword) ||
        item.summary.toLowerCase().includes(keyword) ||
        item.category.toLowerCase().includes(keyword);
      return matchCat && matchQuery;
    });
  }, [activeCat, query]);

  return (
    <section id="events" className="w-full bg-background-100 px-4 md:px-8 py-14 md:py-20">
      <div className="w-full">
        <SectionHeading
          eyebrow="热门事件汇总"
          title="按分类筛选你想看的那一类瓜"
          desc="影视、综艺、音乐、联名、明星动态与短剧出海，点一下就能过滤；也可以用关键词直接搜索事件。"
        />

        <div className="flex flex-col gap-4 mb-8">
          <div className="relative w-full md:max-w-md">
            <i className="ri-search-line absolute left-3.5 top-1/2 -translate-y-1/2 text-foreground-400 text-base" />
            <input
              type="search"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜索事件关键词，例如：番位、门票、剪辑"
              aria-label="搜索热门事件"
              className="w-full pl-10 pr-4 py-2.5 rounded-md border border-background-300 bg-background-50 text-sm text-foreground-900 placeholder:text-foreground-400 outline-none focus:border-primary-500 focus:ring-2 focus:ring-primary-200 transition-colors"
            />
          </div>

          <div className="flex flex-wrap gap-2">
            {tabs.map((tab) => (
              <button
                key={tab}
                type="button"
                onClick={() => setActiveCat(tab)}
                className={`px-3.5 py-1.5 rounded-full text-xs md:text-sm border transition-colors cursor-pointer whitespace-nowrap ${
                  activeCat === tab
                    ? "bg-primary-500 text-background-50 border-primary-500"
                    : "bg-background-50 text-foreground-700 border-background-300 hover:border-primary-400 hover:text-primary-600"
                }`}
              >
                {tab}
              </button>
            ))}
          </div>
        </div>

        {filtered.length === 0 ? (
          <div className="rounded-lg border border-dashed border-background-300 bg-background-50 py-16 text-center">
            <span className="inline-flex w-14 h-14 items-center justify-center rounded-full bg-background-100 text-2xl text-foreground-400 mb-4">
              <i className="ri-emotion-unhappy-line" />
            </span>
            <p className="font-heading font-bold text-foreground-900 mb-1">暂时没有匹配的事件</p>
            <p className="text-sm text-foreground-600 mb-5">换个关键词，或清空筛选看看全部盘点。</p>
            <button
              type="button"
              onClick={() => {
                setQuery("");
                setActiveCat("全部");
              }}
              className="px-4 py-2 rounded-md bg-primary-500 text-background-50 text-sm hover:bg-primary-600 transition-colors cursor-pointer"
            >
              清空筛选条件
            </button>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
            {filtered.map((item) => (
              <article
                key={item.id}
                className="group flex flex-col rounded-lg overflow-hidden border border-background-200 bg-background-50 hover:border-primary-300 transition-colors"
              >
                <div className="relative w-full h-48 overflow-hidden">
                  <img
                    src={item.image}
                    alt={`${item.title} 事件盘点配图`}
                    title={`${item.title} - 5.1吃瓜娱乐盘点`}
                    className="absolute inset-0 w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  />
                  <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-background-50/90 text-primary-700 text-[11px] font-medium backdrop-blur-sm">
                    {item.category}
                  </span>
                  <span className="absolute top-3 right-3 inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-primary-500/95 text-background-50 text-[11px] font-medium">
                    <i className="ri-fire-fill" />
                    {item.tag}
                  </span>
                </div>
                <div className="flex flex-col flex-1 p-4 md:p-5">
                  <h3 className="font-heading font-bold text-foreground-950 text-base md:text-lg leading-snug mb-2 line-clamp-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-600 leading-relaxed mb-4 line-clamp-3 flex-1">
                    {item.summary}
                  </p>
                  <div className="flex items-center justify-between pt-3 border-t border-background-100">
                    <span className="text-xs text-foreground-500">{item.time}</span>
                    <span className="inline-flex items-center gap-1 text-xs text-primary-600 font-medium">
                      <i className="ri-line-chart-line" />
                      {(item.heat / 100).toFixed(1)}k
                    </span>
                  </div>
                </div>
              </article>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}